export default (_, inject) => {
  // simple helper for generating random strings
  inject('randomString', (length=10) => {
    return [...Array(length)].map(i=>(~~(Math.random()*36)).toString(36)).join('')
  })
}
